import axios from "../../AxiosInstance";

const baseUrlApi='/master'
class PlaceService{

    getCountryName(){
        return axios.get(baseUrlApi+'/getCountryName');
    }
    insertCountryName(details){
        return axios.post(baseUrlApi+'/insertCountryName',details);
    }
    updateCountryName(details){
        return axios.put(baseUrlApi+'/updateCountryName',details);
    }
    deleteCountryName(countryId){
        return axios.delete(baseUrlApi+'/deleteCountryName?countryId='+countryId);
    }

    //state
    getDeliveryStateName(){
        return axios.get(baseUrlApi+'/getDeliveryStateName');
    }
    insertDeliveryStateName(details){
        return axios.post(baseUrlApi+'/insertDeliveryStateName',details);
    }
    updateDeliveryStateName(details){
        return axios.put(baseUrlApi+'/updateDeliveryStateName',details);
    }
    deleteDeliveryStateName(deliveryStateId){
        return axios.delete(baseUrlApi+'/deleteDeliveryStateName?deliveryStateId='+deliveryStateId);
    }

    //clrDetails

    getOrganization(){
        return axios.get(baseUrlApi+'/getOrganization');
    }

    insertOrganizationName(details){
        return axios.post(baseUrlApi+'/insertOrganizationName',details);
    }
    updateOrganizationName(details){
        return axios.put(baseUrlApi+'/updateOrganizationName',details);
    }
    deleteOrganizationName(pointId){
        return axios.delete(baseUrlApi+'/deleteOrganizationName?pointId='+pointId);
    }

}
export default new PlaceService();